(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-hero"] && !Shopify.designMode) return;
  try {
    
  class KitShoppableHero extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const signal = this.abortController.signal;

      if (window.theme && window.theme.sections) {
        this.initQuickShop();
      } else {
        document.addEventListener('page:loaded', () => this.initQuickShop(), { once: true, signal });
      }

      if (this.querySelector('kit-popover')) {
        window.addEventListener('scroll', () => {
          this.querySelectorAll('kit-popover:popover-open').forEach(p => p.hidePopover());
        }, { passive: true, signal });
      }

      if (!Shopify.designMode) return;

      document.addEventListener('shopify:section:load', (event) => {
        if (event.target.contains(this)) {
          this.initQuickShop();
        }
      }, { signal });

      this.addEventListener('shopify:block:select', (event) => {
        this.initQuickShop();
        const btn = event.target.querySelector('button');
        if (btn) btn.click();
      }, { signal });

      this.addEventListener('shopify:block:deselect', (event) => {
        const popover = event.target.querySelector('kit-popover');
        if (popover) popover.hidePopover?.();
      }, { signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    initQuickShop() {
      if (!theme.settings.quickView) return;

      var sectionEl = this.closest('[id^="shopify-section-"]');
      var links = this.querySelectorAll('.shoppable-hero__popover-link[data-product-handle]');
      if (!links.length) return;

      links.forEach(link => {
        if (link.dataset.shoppableHeroBound === 'true') return;
        link.dataset.shoppableHeroBound = 'true';

        var handle = link.dataset.productHandle;
        var productId = link.dataset.productId;

        if (!document.getElementById('QuickShopModal-' + productId)) return;

        // Capture-phase interceptor registered before modal binds its handler.
        // On mobile, blocks the modal handler so the link navigates normally.
        link.addEventListener('click', (event) => {
          if (theme.config.bpSmall) {
            event.stopImmediatePropagation();
            return;
          }
          const popover = event.target.closest('kit-popover');
          if (popover) popover.hidePopover?.();
        }, true);

        var hotspot = link.closest('.kit-shoppable-hero__hotspot');
        if (!hotspot) return;

        var preloadOnce = function() {
          if (link.dataset.shoppableHeroPreloaded === 'true') return;
          if (theme.config.bpSmall) return;

          // If a holder already exists from another section (e.g. product grid),
          // remove our duplicate modal shell to avoid duplicate IDs
          var holder = document.getElementById('QuickShopHolder-' + handle);
          if (holder && sectionEl) {
            var holderSection = holder.closest('[id^="shopify-section-"]');
            if (holderSection && holderSection !== sectionEl) {
              var duplicate = sectionEl.querySelector('#QuickShopModal-' + productId);
              if (duplicate) duplicate.remove();
            }
          }

          link.dataset.shoppableHeroPreloaded = 'true';
          link.classList.add('js-modal-open-quick-modal-' + productId);
          theme.preloadProductModal(handle, productId, link);

          hotspot.removeEventListener('mouseover', preloadOnce);
          hotspot.removeEventListener('focusin', preloadOnce);
        };

        hotspot.addEventListener('mouseover', preloadOnce);
        hotspot.addEventListener('focusin', preloadOnce);
      });
    }
  }

  customElements.define('kit-shoppable-hero', KitShoppableHero);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testemunhos-personalizados"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('pt-reviews-slider')) {
  customElements.define('pt-reviews-slider', class extends HTMLElement {
    connectedCallback() {
      if (this._controller) return;
      this._controller = new AbortController();
      const signal = this._controller.signal;
      this.track = this.querySelector('.pt-reviews__track');
      this.previous = this.querySelector('[data-pr-previous]');
      this.next = this.querySelector('[data-pr-next]');
      if (!this.track) return;
      this.track.addEventListener('scroll', () => this.queueUpdate(), { passive: true, signal });
      this.previous?.addEventListener('click', () => this.move(-1), { signal });
      this.next?.addEventListener('click', () => this.move(1), { signal });
      this.track.addEventListener('keydown', event => {
        if (event.target !== this.track) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          this.move(event.key === 'ArrowRight' ? 1 : -1);
        } else if (event.key === 'Home' || event.key === 'End') {
          event.preventDefault();
          this.track.scrollTo({ left: event.key === 'Home' ? 0 : this.track.scrollWidth, behavior: this.behavior() });
        }
      }, { signal });
      document.addEventListener('shopify:block:select', event => {
        if (!this.contains(event.target)) return;
        const card = event.target.closest('.pt-reviews__card');
        if (card) this.track.scrollTo({ left: card.offsetLeft - this.track.firstElementChild.offsetLeft, behavior: 'auto' });
      }, { signal });
      this._resize = new ResizeObserver(() => this.queueUpdate());
      this._resize.observe(this.track);
      this.queueUpdate();
    }
    disconnectedCallback() {
      this._controller?.abort();
      this._resize?.disconnect();
      cancelAnimationFrame(this._frame);
      this._controller = null;
    }
    behavior() {
      return matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
    }
    move(direction) {
      const cards = Array.from(this.track.children);
      if (cards.length < 2) return;
      const start = cards[0].offsetLeft;
      const positions = cards.map(card => card.offsetLeft - start);
      const current = this.track.scrollLeft;
      const target = direction > 0
        ? positions.find(position => position > current + 2)
        : positions.reverse().find(position => position < current - 2);
      if (target !== undefined) this.track.scrollTo({ left: target, behavior: this.behavior() });
    }
    queueUpdate() {
      cancelAnimationFrame(this._frame);
      this._frame = requestAnimationFrame(() => this.update());
    }
    update() {
      const maximum = this.track.scrollWidth - this.track.clientWidth;
      const current = this.track.scrollLeft;
      if (this.previous) this.previous.disabled = current <= 2;
      if (this.next) this.next.disabled = maximum <= 2 || current >= maximum - 2;
      const hint = this.querySelector('.pt-reviews__hint');
      if (hint) hint.hidden = maximum <= 2;
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
